// Fetch the Auth Configurations
export const getAppInsightInfo = async () => {
  const response = await fetch('/authConfig.json');
  const configs = await response.json();
  return configs[2].AppInsightInfo;
};